import { render, staticRenderFns } from "./Noun.vue?vue&type=template&id=09cfec79&scoped=true&"
import script from "./Noun.vue?vue&type=script&lang=js&"
export * from "./Noun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cfec79",
  null
  
)

export default component.exports